import { TabsContent } from "@/shared/components/ui/tabs";
import MasterDatabasePage from "@/modules/adminPortal/Components/admin/MasterDatabasePage";

export default function ResumeDatabaseTab() {
  return (
    <TabsContent value="database">
      <MasterDatabasePage />
    </TabsContent>
  );
}